import { RequestCumulativeCampaignReportDTO } from "@intentsify/dto";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { Endpoints, apiService } from "api";
import { AsyncReturnType } from "type-fest";

type Params = {
  id: string;
  params: RequestCumulativeCampaignReportDTO;
};

const requestCumulativeCampaignReport = ({ id, params }: Params) =>
  apiService.post(Endpoints.Reports.CumulativeReport.Post.Request(id), {
    ...params,
  });

type UseRequestCumulativeCampaignReportOptions = UseMutationOptions<
  AsyncReturnType<typeof requestCumulativeCampaignReport>,
  unknown,
  { id: string; params: RequestCumulativeCampaignReportDTO }
>;

export const useRequestCumulativeCampaignReport = (
  options?: UseRequestCumulativeCampaignReportOptions
) => {
  return useMutation({
    mutationFn: requestCumulativeCampaignReport,
    ...options,
  });
};
